import { navigate } from '@reach/router';
import React, { ReactElement, useEffect, useState } from 'react';
import Block from '../../../../block';
import Meta from '../../../../meta';
import LibraryNav from '../library-nav';
import SearchResults from '../search-results';
import './style.css';

interface IProps {
  children: any;
}

// The main part of the library page that shows the content.
// This is also where we handle some of our search functionality.
export default function LibraryMain({ children }: IProps): ReactElement {
  const [isShowingSearch, setIsShowingSearch] = useState<boolean>(false);
  const [searchInputVal, setSearchInputVal] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState<string>('');

  // Putting this at the top because of limitations of gatsby's history
  // to not include search params.
  let searchParam;
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    searchParam = urlParams.get('search');
  }

  const handleSearchChange = (value: string) => {
    setSearchInputVal(value);
  };

  const handleStartSearch = () => {
    navigate(`/library/?search=${searchInputVal}`);
    handleSearchChange(searchInputVal);
    setIsShowingSearch(true);
    setSearchQuery(searchInputVal);
  };

  const handleHideSearchResults = () => {
    setIsShowingSearch(false);
  };

  useEffect(() => {
    if (searchParam) {
      handleSearchChange(searchParam);
      setIsShowingSearch(true);
      setSearchQuery(searchParam);
    } else {
      setIsShowingSearch(false);
    }
  }, [searchParam]);

  return (
    <Block width={1200}>
      <Meta
        title="Library: Accessibility resources, guides, communities, and more"
        siteName="Stark Library"
        description="Discover the world’s best accessibility resources, curated for you."
        ogTitle="Stark’s Public Library – Accessibility resources, guides, communities, and more"
        ogUrl="https://getstark.co/library"
        ogImgUrl="https://images.getstark.co/marketing/meta/library.png">
        <link
          rel="alternate"
          type="application/rss+xml"
          title="Stark Library"
          href="https://getstark.co/library-rss.xml"
        />
      </Meta>

      <div className="library-main__wrapper flex">
        <LibraryNav
          onSearchInputChange={handleSearchChange}
          onSearch={handleStartSearch}
          onHideSearchResults={handleHideSearchResults}
        />

        <main className="library-main ml-16 mt-16 w-full" id="main">
          {isShowingSearch ? (
            <SearchResults searchQuery={searchQuery} />
          ) : (
            <>{children}</>
          )}
        </main>
      </div>
    </Block>
  );
}
